import React from 'react';
import moment from 'moment';
import cn from 'classnames';
import { getGridColumn } from '../utils';
import { views } from '../../../constants/views';
import { modes } from '../../../constants/modes';
import { useCalendarState } from '../../../context/CalendarContext';
import styles from '../CalendarGrid.module.scss';

const TopRow = () => {
  const { view, calendarSheet, mode } = useCalendarState();

  if (view === views.day || mode === modes.agenda) {
    return <div className={styles.sideCellWrapper} />;
  }

  return Array.from(Array(7)).map((_, index) => {
    const day = calendarSheet
      ?.clone()
      .startOf('week')
      .days(index + 1);

    return (
      <div
        key={index}
        className={cn(
          styles.sideCellWrapper,
          styles.topRow,
          styles.borderRight
        )}
        style={{
          gridColumn: getGridColumn(index),
          gridRow: '1/2',
        }}
      >
        <p
          className={cn(styles.time, styles.weekDay, {
            [styles.weekView]: view === views.week,
            [styles.currentDay]:
              view === views.week && day?.isSame(moment(), 'day'),
          })}
        >
          {day ? day.format('ddd') : ''}
          {view === views.week && (
            <span style={{ marginTop: '5px', fontSize: '11px' }}>
              {day ? day.format('D') : ''}
            </span>
          )}
        </p>
      </div>
    );
  });
};

export default TopRow;
